module.exports = __webpack_public_path__ + "img/jiaju6_active.01b7cc39.png";